import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VideotutorialService {
  private httpPublicClient: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private HttpBackend: HttpBackend
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  getVideosActivosByRespuesta(respuestaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/videoTutoriales/activosByRespuesta?respuestaId=${respuestaId}`
      )
    );
  }

  getVideosActivosByPregunta(preguntaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/videoTutoriales/activosByPregunta?preguntaId=${preguntaId}`
      )
    );
  }

  getVideosActivosByPreguntaPublic(preguntaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/videoTutorialesByPregunta?preguntaId=${preguntaId}`
      )
    );
  }

  getVideoById(videoId: number) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/videoTutoriales/${videoId}`)
    );
  }

  crearVideo(video: { nombre: string; url: string; tipo: string }) {
    const formData = new FormData();
    formData.append('nombre', video.nombre.trim());
    formData.append('descripcion', video.url.trim());
    formData.append('tipo', video.tipo);
    formData.append('respuestaId', sessionStorage.getItem('respuestaId'));

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/videoTutoriales`),
      formData
    );
  }

  modificarVideo(
    videoId: string,
    video: {
      nombre: string;
      url: string;
      tipo: string;
    }
  ) {
    const formData = new FormData();
    formData.append('nombre', video.nombre.trim());
    formData.append('descripcion', video.url.trim());
    formData.append('tipo', video.tipo);
    formData.append('respuestaId', sessionStorage.getItem('respuestaId'));

    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/videoTutoriales/${videoId}`),
      formData
    );
  }

  eliminarVideo(videoId: number) {
    return this.httpClient.delete(
      encodeURI(`${environment.apiURL}/videoTutoriales/${videoId}`)
    );
  }
}
